module.exports = __webpack_public_path__ + "img/slot.27326fd9.png";